import {
    MANAGE_ASSIGNABLE_ROLES,
    ROLE_DEFINITIONS,
    isManageAssignableRole,
    isValidRole,
} from '@wevo/wevo-access';

/**
 * Why removing this role from Manage would not stick, or null when it would.
 * Mirrors the ensure-pulse-user-role-post-login Action (infrastructure repo), which on every
 * organization login re-adds pulse_user, and re-adds pro_user when the member holds no pro_* role.
 */
export function getLoginRegrantReason(role: string, heldRoles: readonly string[]): string | null {
    if (role === 'pulse_user') {
        return 'Added back at every sign-in.';
    }
    if (
        role === 'pro_user' &&
        !heldRoles.some((held) => held !== role && held.startsWith('pro_'))
    ) {
        return 'Added back at sign-in unless the user has another PRO role. Assign pro_approver or pro_restricted first.';
    }
    return null;
}

export function getRoleDescription(role: string): string | null {
    return isValidRole(role) ? ROLE_DEFINITIONS[role].description : null;
}

/** Manage-assignable roles the user does not hold yet, in manifest order. */
export function getAddableRoles(heldRoles: readonly string[]): string[] {
    return MANAGE_ASSIGNABLE_ROLES.filter((role) => !heldRoles.includes(role));
}

export function canRemoveRoleFromManage(role: string, heldRoles: readonly string[]): boolean {
    return isManageAssignableRole(role) && getLoginRegrantReason(role, heldRoles) === null;
}
